/* VCTparts chatassistent op de webshop, versie __VERSIE__.
   Gemaakt voor het VCTparts-paneel; niet met de hand aanpassen. Kleuren komen uit de --vct-*-variabelen van de webshop;
   kop, laag en hoogte boven een koopbalk stel je in in vct-chat.liquid. Ontwerp en regels: docs/chat-bouwspec.md.
   Veiligheid: geen innerHTML en geen eval; alle tekst gaat via textContent; links alleen naar de eigen winkels en de
   vervoerders; het sessietoken gaat nooit in een adres; ordernummer en e-mail gaan alleen naar de controle, nooit
   in een chatbericht. Zonder "aan" van de chatdienst toont het venster niets. */
(() => {
  "use strict";
  const host = document.getElementById("vct-chat");
  if (!host || host.shadowRoot || host.getAttribute("data-vct-klaar")) return;
  host.setAttribute("data-vct-klaar", "1");

  const d = host.dataset;
  const API = String(d.api || "").replace(/\/+$/, "");       // de aparte chatdienst (chat.vctparts.nl), nooit de backoffice
  const API_OK = /^https:\/\/[a-z0-9.-]+(?::\d{1,5})?$/i.test(API);
  const VOORBEELD = d.voorbeeld === "1";
  const PAGINA = String(d.pagina || "").toLowerCase();
  const ROOT = (() => {
    let r = String(d.root || "/");
    if (!/^\/(?![/\\])/.test(r) || /[\\\s]/.test(r)) r = "/";
    return r.endsWith("/") ? r : r + "/";
  })();
  const GELD = String(d.geld || "");
  const VALUTA = /^[A-Z]{3}$/.test(String(d.valuta || "")) ? String(d.valuta) : "EUR";
  // Geen pad van accountpagina's: daar staan wachtwoord-reset- en activatiecodes in het adres.
  const PAD = PAGINA.startsWith("customers/") || /\/account(\/|$)/.test(location.pathname) ? "/account" : location.pathname.slice(0, 200);
  const TAAL = (() => {
    const t = String(d.taal || document.documentElement.lang || "nl").slice(0, 2).toLowerCase();
    return ["nl", "de", "fr", "en"].includes(t) ? t : "nl";
  })();
  const LOCALE = { nl: "nl-NL", de: "de-DE", fr: "fr-BE", en: "en-GB" }[TAAL];
  const RUSTIG = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // Mobiel = smal scherm of een telefoon die liggend wordt gehouden (dezelfde vraag voor CSS via de klasse .mobiel).
  const MOBIEL = window.matchMedia ? window.matchMedia("(max-width: 640px), (max-height: 500px) and (pointer: coarse)") : { matches: false, addEventListener() {} };

  // talen:begin (tests/test_chatvenster.py controleert dat elke taal alle sleutels heeft)
  const TALEN = {
    nl: {
      open: "Chat openen", sluit: "Chat sluiten", menu: "Meer opties", nieuw: "Nieuw gesprek", mens: "Praat met een medewerker",
      titel: "VCTparts assistent", sub: "AI-assistent", voorbeeld: "voorbeeld", log_label: "Gesprek",
      invoer_label: "Je bericht", invoer_ph: "Typ je vraag…", verstuur: "Versturen", nieuw_bericht: "Nieuw bericht ↓",
      welkom: "Hoi! Ik ben de **AI-assistent** van VCTparts. Ik help je met productadvies, je bestelling, retourneren en ruilen. Liever een mens? Kies dan **Praat met een medewerker**.",
      snel: ["Waar is mijn bestelling?", "Retourneren of ruilen", "Welke lamp past op mijn auto?", "Praat met een medewerker"],
      uitnodiging_product: "Vragen over dit product? Onze AI-assistent helpt je graag.",
      uitnodiging_collectie: "Hulp nodig bij het kiezen? Vraag het onze AI-assistent.",
      uitnodiging_sluit: "Uitnodiging sluiten", ongelezen: "{n} ongelezen",
      vertaald: "Automatisch vertaald uit het Nederlands.",
      in_winkelwagen: "In winkelwagen", toegevoegd: "Toegevoegd", bekijk_prijs: "Bekijk de prijs op de productpagina",
      sterren: "{w} van 5 sterren", aantal: "{n} beoordelingen",
      fout: "Er ging iets mis. Probeer het nog eens, of mail ons via info@vctparts.nl.",
      fout_winkelwagen: "Toevoegen lukte niet. Probeer het op de productpagina.",
      lead_titel: "Mogen we je ook mailen?", lead_uitleg: "Laat je e-mailadres achter, dan krijg je ons antwoord ook per mail als je de chat sluit.",
      email: "E-mailadres", naam: "Naam (niet verplicht)", meldingen: "Mail me als er een antwoord is", opslaan: "Opslaan", overslaan: "Overslaan",
      lead_ok: "Dank je, we hebben je e-mailadres.", ongeldig_email: "Vul een geldig e-mailadres in.",
      mens_bezig: "Ik zet je door naar een medewerker. Je gesprek staat nu bij onze klantenservice; je krijgt hier antwoord, of per mail als je de chat sluit.",
      team: "Mel en Lindsey, klantenservice", typen: "Aan het typen",
      feedback_vraag: "Heb ik je goed geholpen?", ja: "Ja", nee: "Nee", feedback_dank: "Bedankt voor je reactie!",
      prijs_nu: "Prijs", prijs_advies: "adviesprijs",
      vandaag: "Vandaag", privacy: "Privacybeleid", disclaimer: "Antwoorden van de AI kunnen fouten bevatten. Deel geen wachtwoorden of betaalgegevens.",
      verifieer_titel: "Je bestelling opzoeken", verifieer_uitleg: "Vul je ordernummer en het e-mailadres van je bestelling in. Zonder die twee kunnen we niets over een bestelling vertellen.",
      ordernummer: "Ordernummer", controleren: "Opzoeken", ongeldig_order: "Vul een ordernummer in.",
      verifieer_fout: "We kunnen deze combinatie niet vinden. Controleer het ordernummer en het e-mailadres van je bestelling.",
      actie_ja: "Ja, annuleren", actie_nee: "Nee",
      demo_verifieer: "Dat zoek ik graag voor je op. Vul hieronder je ordernummer en e-mailadres in.",
      demo_status: "Gevonden: **bestelling #{nr}**. Die is nog niet verzonden. Wil je iets aanpassen of annuleren?",
      demo_actie: "Bestelling #{nr} annuleren? Je krijgt €49,95 terug op je oorspronkelijke betaalmethode.",
      demo_geannuleerd: "Je bestelling #{nr} is geannuleerd. Je krijgt een bevestiging per mail.", demo_niet: "Prima, er verandert niets aan je bestelling.",
      demo_antwoord: "Goede keuze om te upgraden! Voor een **Volkswagen Golf 7 met halogeen** heb je **H7**-lampen nodig. Mijn advies:\n- **LED-lampen H7**, per set van 2\n- In 97% van de gevallen canbus-vrij; twijfel je, neem dan een **canbus-weerstand** mee\n\nAlle H7-lampen zie je via [zoeken op H7](/search?q=H7).",
      demo_mens: "Hoi, met Mel van de klantenservice. Ik kijk even met je mee: wat is je ordernummer?",
      demo_product: "Voorbeeldproduct: LED-lampen H7 (set van 2)", demo_product2: "Voorbeeldproduct: canbus-weerstand H7",
    },
    de: {
      open: "Chat öffnen", sluit: "Chat schließen", menu: "Weitere Optionen", nieuw: "Neues Gespräch", mens: "Mit einem Mitarbeiter sprechen",
      titel: "VCTparts Assistent", sub: "KI-Assistent", voorbeeld: "Vorschau", log_label: "Gespräch",
      invoer_label: "Deine Nachricht", invoer_ph: "Schreib deine Frage…", verstuur: "Senden", nieuw_bericht: "Neue Nachricht ↓",
      welkom: "Hallo! Ich bin der **KI-Assistent** von VCTparts. Ich helfe dir bei der Produktwahl, deiner Bestellung, Rücksendungen und beim Umtausch. Lieber mit einem Menschen sprechen? Wähle **Mit einem Mitarbeiter sprechen**.",
      snel: ["Wo ist meine Bestellung?", "Zurücksenden oder umtauschen", "Welche Lampe passt in mein Auto?", "Mit einem Mitarbeiter sprechen"],
      uitnodiging_product: "Fragen zu diesem Produkt? Unser KI-Assistent hilft dir gern.",
      uitnodiging_collectie: "Hilfe bei der Auswahl? Frag unseren KI-Assistenten.",
      uitnodiging_sluit: "Einladung schließen", ongelezen: "{n} ungelesen",
      vertaald: "Automatisch aus dem Niederländischen übersetzt.",
      in_winkelwagen: "In den Warenkorb", toegevoegd: "Hinzugefügt", bekijk_prijs: "Preis auf der Produktseite ansehen",
      sterren: "{w} von 5 Sternen", aantal: "{n} Bewertungen",
      fout: "Da ist etwas schiefgelaufen. Versuch es bitte noch einmal oder schreib uns an info@vctparts.nl.",
      fout_winkelwagen: "Das hat nicht geklappt. Versuch es auf der Produktseite.",
      lead_titel: "Dürfen wir dir auch mailen?", lead_uitleg: "Hinterlasse deine E-Mail-Adresse, dann bekommst du unsere Antwort auch per E-Mail, wenn du den Chat schließt.",
      email: "E-Mail-Adresse", naam: "Name (optional)", meldingen: "Schick mir eine E-Mail, wenn es eine Antwort gibt", opslaan: "Speichern", overslaan: "Überspringen",
      lead_ok: "Danke, wir haben deine E-Mail-Adresse.", ongeldig_email: "Bitte gib eine gültige E-Mail-Adresse ein.",
      mens_bezig: "Ich leite dich an einen Mitarbeiter weiter. Dein Gespräch liegt jetzt bei unserem Kundenservice; du bekommst hier eine Antwort, oder per E-Mail, wenn du den Chat schließt.",
      team: "Mel und Lindsey, Kundenservice", typen: "Schreibt",
      feedback_vraag: "Konnte ich dir helfen?", ja: "Ja", nee: "Nein", feedback_dank: "Danke für dein Feedback!",
      prijs_nu: "Preis", prijs_advies: "UVP",
      vandaag: "Heute", privacy: "Datenschutz", disclaimer: "Antworten der KI können Fehler enthalten. Teile keine Passwörter oder Zahlungsdaten.",
      verifieer_titel: "Bestellung suchen", verifieer_uitleg: "Gib deine Bestellnummer und die E-Mail-Adresse deiner Bestellung ein. Ohne beides können wir nichts zu einer Bestellung sagen.",
      ordernummer: "Bestellnummer", controleren: "Suchen", ongeldig_order: "Bitte gib eine Bestellnummer ein.",
      verifieer_fout: "Wir finden diese Kombination nicht. Prüfe die Bestellnummer und die E-Mail-Adresse deiner Bestellung.",
      actie_ja: "Ja, stornieren", actie_nee: "Nein",
      demo_verifieer: "Das schaue ich gern für dich nach. Gib unten deine Bestellnummer und E-Mail-Adresse ein.",
      demo_status: "Gefunden: **Bestellung #{nr}**. Sie ist noch nicht versendet. Möchtest du etwas ändern oder stornieren?",
      demo_actie: "Bestellung #{nr} stornieren? Du bekommst 49,95 € auf deine ursprüngliche Zahlungsart zurück.",
      demo_geannuleerd: "Deine Bestellung #{nr} wurde storniert. Du bekommst eine Bestätigung per E-Mail.", demo_niet: "Alles klar, an deiner Bestellung ändert sich nichts.",
      demo_antwoord: "Gute Wahl! Für einen **VW Golf 7 mit Halogen** brauchst du **H7**-Lampen. Mein Tipp:\n- **LED-Lampen H7**, im 2er-Set\n- In 97 % der Fälle Canbus-frei; im Zweifel nimm einen **Canbus-Widerstand** dazu\n\nAlle H7-Lampen findest du über die [Suche nach H7](/search?q=H7).",
      demo_mens: "Hallo, hier ist Mel vom Kundenservice. Ich schaue mir das gern an: Wie lautet deine Bestellnummer?",
      demo_product: "Beispielprodukt: LED-Lampen H7 (2er-Set)", demo_product2: "Beispielprodukt: Canbus-Widerstand H7",
    },
    fr: {
      open: "Ouvrir le chat", sluit: "Fermer le chat", menu: "Plus d'options", nieuw: "Nouvelle conversation", mens: "Parler à un conseiller",
      titel: "Assistant VCTparts", sub: "Assistant IA", voorbeeld: "aperçu", log_label: "Conversation",
      invoer_label: "Votre message", invoer_ph: "Posez votre question…", verstuur: "Envoyer", nieuw_bericht: "Nouveau message ↓",
      welkom: "Bonjour ! Je suis l'**assistant IA** de VCTparts. Je vous aide à choisir un produit, pour votre commande, les retours et les échanges. Vous préférez parler à une personne ? Choisissez **Parler à un conseiller**.",
      snel: ["Où est ma commande ?", "Retourner ou échanger", "Quelle ampoule pour ma voiture ?", "Parler à un conseiller"],
      uitnodiging_product: "Une question sur ce produit ? Notre assistant IA vous aide volontiers.",
      uitnodiging_collectie: "Besoin d'aide pour choisir ? Demandez à notre assistant IA.",
      uitnodiging_sluit: "Fermer l'invitation", ongelezen: "{n} non lu(s)",
      vertaald: "Traduit automatiquement du néerlandais.",
      in_winkelwagen: "Ajouter au panier", toegevoegd: "Ajouté", bekijk_prijs: "Voir le prix sur la page produit",
      sterren: "{w} sur 5 étoiles", aantal: "{n} avis",
      fout: "Une erreur s'est produite. Réessayez ou écrivez-nous à info@vctparts.nl.",
      fout_winkelwagen: "L'ajout n'a pas fonctionné. Essayez depuis la page produit.",
      lead_titel: "Pouvons-nous aussi vous écrire ?", lead_uitleg: "Laissez votre adresse e-mail pour recevoir aussi notre réponse par e-mail si vous fermez le chat.",
      email: "Adresse e-mail", naam: "Nom (facultatif)", meldingen: "M'envoyer un e-mail lors d'une réponse", opslaan: "Enregistrer", overslaan: "Passer",
      lead_ok: "Merci, nous avons bien votre adresse e-mail.", ongeldig_email: "Veuillez saisir une adresse e-mail valide.",
      mens_bezig: "Je vous mets en relation avec un conseiller. Votre conversation est transmise à notre service client ; vous recevrez la réponse ici, ou par e-mail si vous fermez le chat.",
      team: "Mel et Lindsey, service client", typen: "En train d'écrire",
      feedback_vraag: "Ai-je pu vous aider ?", ja: "Oui", nee: "Non", feedback_dank: "Merci pour votre avis !",
      prijs_nu: "Prix", prijs_advies: "prix conseillé",
      vandaag: "Aujourd'hui", privacy: "Politique de confidentialité", disclaimer: "Les réponses de l'IA peuvent contenir des erreurs. Ne partagez ni mots de passe ni données de paiement.",
      verifieer_titel: "Retrouver votre commande", verifieer_uitleg: "Saisissez votre numéro de commande et l'adresse e-mail de la commande. Sans ces deux informations, nous ne pouvons rien vous dire sur une commande.",
      ordernummer: "Numéro de commande", controleren: "Rechercher", ongeldig_order: "Veuillez saisir un numéro de commande.",
      verifieer_fout: "Nous ne trouvons pas cette combinaison. Vérifiez le numéro de commande et l'adresse e-mail de votre commande.",
      actie_ja: "Oui, annuler", actie_nee: "Non",
      demo_verifieer: "Je regarde cela avec plaisir. Saisissez ci-dessous votre numéro de commande et votre adresse e-mail.",
      demo_status: "Trouvée\u00a0: **commande #{nr}**. Elle n'est pas encore expédiée. Souhaitez-vous modifier ou annuler quelque chose\u00a0?",
      demo_actie: "Annuler la commande #{nr}\u00a0? Vous serez remboursé de 49,95\u00a0€ sur votre moyen de paiement d'origine.",
      demo_geannuleerd: "Votre commande #{nr} a été annulée. Vous recevrez une confirmation par e-mail.", demo_niet: "Très bien, rien ne change pour votre commande.",
      demo_antwoord: "Bon choix ! Pour une **Volkswagen Golf 7 avec halogène**, il vous faut des ampoules **H7**. Mon conseil :\n- **Ampoules LED H7**, par lot de 2\n- Compatibles Canbus dans 97 % des cas ; en cas de doute, ajoutez une **résistance Canbus**\n\nToutes les ampoules H7 : [rechercher H7](/search?q=H7).",
      demo_mens: "Bonjour, ici Mel du service client. Je regarde cela avec vous : quel est votre numéro de commande ?",
      demo_product: "Produit d'exemple : ampoules LED H7 (lot de 2)", demo_product2: "Produit d'exemple : résistance Canbus H7",
    },
    en: {
      open: "Open chat", sluit: "Close chat", menu: "More options", nieuw: "New conversation", mens: "Talk to a team member",
      titel: "VCTparts assistant", sub: "AI assistant", voorbeeld: "preview", log_label: "Conversation",
      invoer_label: "Your message", invoer_ph: "Type your question…", verstuur: "Send", nieuw_bericht: "New message ↓",
      welkom: "Hi! I'm the **AI assistant** of VCTparts. I can help with product advice, your order, returns and exchanges. Prefer a person? Choose **Talk to a team member**.",
      snel: ["Where is my order?", "Return or exchange", "Which bulb fits my car?", "Talk to a team member"],
      uitnodiging_product: "Questions about this product? Our AI assistant is happy to help.",
      uitnodiging_collectie: "Need help choosing? Ask our AI assistant.",
      uitnodiging_sluit: "Close invitation", ongelezen: "{n} unread",
      vertaald: "Automatically translated from Dutch.",
      in_winkelwagen: "Add to cart", toegevoegd: "Added", bekijk_prijs: "See the price on the product page",
      sterren: "{w} out of 5 stars", aantal: "{n} reviews",
      fout: "Something went wrong. Please try again, or email us at info@vctparts.nl.",
      fout_winkelwagen: "Adding failed. Please try on the product page.",
      lead_titel: "May we email you as well?", lead_uitleg: "Leave your email address and you will also get our reply by email if you close the chat.",
      email: "Email address", naam: "Name (optional)", meldingen: "Email me when there is a reply", opslaan: "Save", overslaan: "Skip",
      lead_ok: "Thank you, we have your email address.", ongeldig_email: "Please enter a valid email address.",
      mens_bezig: "I'm passing you on to a team member. Your conversation is now with our customer service; you will get a reply here, or by email if you close the chat.",
      team: "Mel and Lindsey, customer service", typen: "Typing",
      feedback_vraag: "Did I help you?", ja: "Yes", nee: "No", feedback_dank: "Thanks for your feedback!",
      prijs_nu: "Price", prijs_advies: "list price",
      vandaag: "Today", privacy: "Privacy policy", disclaimer: "AI answers may contain mistakes. Don't share passwords or payment details.",
      verifieer_titel: "Find your order", verifieer_uitleg: "Enter your order number and the email address of your order. Without both we can't share anything about an order.",
      ordernummer: "Order number", controleren: "Look up", ongeldig_order: "Please enter an order number.",
      verifieer_fout: "We can't find this combination. Please check the order number and the email address of your order.",
      actie_ja: "Yes, cancel", actie_nee: "No",
      demo_verifieer: "Happy to look that up. Enter your order number and email address below.",
      demo_status: "Found: **order #{nr}**. It hasn't shipped yet. Would you like to change or cancel anything?",
      demo_actie: "Cancel order #{nr}? You'll get €49.95 back on your original payment method.",
      demo_geannuleerd: "Your order #{nr} has been cancelled. You will receive a confirmation by email.", demo_niet: "Alright, nothing changes to your order.",
      demo_antwoord: "Good choice! For a **Volkswagen Golf 7 with halogen** you need **H7** bulbs. My advice:\n- **LED bulbs H7**, set of 2\n- Canbus-free in 97% of cases; if in doubt, add a **canbus resistor**\n\nSee all H7 bulbs via [search for H7](/search?q=H7).",
      demo_mens: "Hi, this is Mel from customer service. Let me have a look: what is your order number?",
      demo_product: "Sample product: LED bulbs H7 (set of 2)", demo_product2: "Sample product: canbus resistor H7",
    },
  };
  // talen:eind
  const T = Object.assign({}, TALEN.nl, TALEN[TAAL]);

  // ---------- opslag (privévenster of geblokkeerde opslag: dan werkt alles, alleen zonder onthouden) ----------
  const K = { sessie: "vct-chat:sessie", status: "vct-chat:status", overdracht: "vct-chat:overdracht", gelezen: "vct-chat:gelezen",
    lead: "vct-chat:lead", uitgenodigd: "vct-chat:uitgenodigd", weg: "vct-chat:uitnodiging-weg",
    uitgenodigdOp: "vct-chat:uitgenodigd-op", actief: "vct-chat:actief" };
  const lees = (soort, k) => { try { const s = window[soort]; return s ? s.getItem(k) : null; } catch (e) { return null; } };
  const schrijf = (soort, k, v) => {
    try { const s = window[soort]; if (!s) return; if (v == null) s.removeItem(k); else s.setItem(k, String(v)); } catch (e) { /* zonder onthouden */ }
  };

  // ---------- kleine hulpjes ----------
  const el = (tag, cls, tekst) => {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (tekst != null) e.textContent = tekst;
    return e;
  };
  const attr = (e, a) => { for (const k of Object.keys(a)) if (a[k] != null) e.setAttribute(k, String(a[k])); return e; };
  const knopEl = (cls, tekst) => { const b = el("button", cls, tekst); b.type = "button"; return b; };
  const wacht = (ms) => new Promise((r) => setTimeout(r, ms));
  const signaal = (ms) => { const c = new AbortController(); setTimeout(() => c.abort(), ms); return c.signal; };
  const vul = (tekst, waarden) => String(tekst).replace(/\{(\w+)\}/g, (m, k) => (k in waarden ? String(waarden[k]) : m));

  const PADEN = {
    sluit: "M6 6l12 12M18 6L6 18", omlaag: "M6 9l6 6 6-6", meer: "M5 12h.01M12 12h.01M19 12h.01",
    verstuur: "M5 12h14M13 6l6 6-6 6", foto: "M4 6h16v12H4zM4 15l5-5 4 4 3-3 4 4",
  };
  const icoon = (naam, maat) => {
    const NS = "http://www.w3.org/2000/svg";
    const s = document.createElementNS(NS, "svg");
    attr(s, { width: maat || 20, height: maat || 20, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor",
      "stroke-width": naam === "meer" ? 3 : 2, "stroke-linecap": "round", "stroke-linejoin": "round", "aria-hidden": "true", focusable: "false" });
    const p = document.createElementNS(NS, "path");
    p.setAttribute("d", PADEN[naam]);
    s.appendChild(p);
    return s;
  };

  // ---------- links en foto's: alleen de eigen winkels en de vervoerders ----------
  const EIGEN = ["vctparts.nl", "vctparts.be", "vctparts.de"];
  const VERVOERDERS = ["dhl.com", "dhl.nl", "dhlparcel.nl", "dhlecommerce.nl", "postnl.nl", "postnl.be", "postnl.post"];
  const onder = (h, basis) => h === basis || h.endsWith("." + basis);
  const veiligeLink = (ruw) => {
    const s = String(ruw == null ? "" : ruw).trim();
    if (!s || s.length > 2000 || /[\\\u0000-\u001f]/.test(s)) return null;
    let u;
    try { u = new URL(s, location.href); } catch (e) { return null; }
    if (u.username || u.password) return null;
    const h = u.hostname.toLowerCase();
    if (h && h === location.hostname.toLowerCase() && u.protocol === location.protocol && /^https?:$/.test(u.protocol)) return { href: u.href, extern: false };
    if (u.protocol !== "https:") return null;
    if (EIGEN.some((b) => onder(h, b))) return { href: u.href, extern: false };
    if (VERVOERDERS.some((b) => onder(h, b))) return { href: u.href, extern: true };
    return null;
  };
  const veiligeFoto = (ruw) => {
    const s = String(ruw == null ? "" : ruw).trim();
    if (!s || s.length > 2000) return null;
    try {
      const u = new URL(s, location.href);
      if (u.protocol === "https:" || (u.protocol === location.protocol && u.hostname === location.hostname && /^https?:$/.test(u.protocol))) return u.href;
    } catch (e) { /* ongeldig */ }
    return null;
  };

  // ---------- opmaak: vet, opsommingen en links; al het andere is gewone tekst ----------
  const INLINE = /\*\*([^*\n]+)\*\*|\[([^\]\n]{1,200})\]\(([^)\s]{1,2000})\)|(https:\/\/[^\s<>()]+[^\s<>().,;:!?'"])/g;
  const inline = (ouder, tekst) => {
    const re = new RegExp(INLINE.source, "g");
    let pos = 0, m;
    while ((m = re.exec(tekst))) {
      if (m.index > pos) ouder.appendChild(document.createTextNode(tekst.slice(pos, m.index)));
      if (m[1] != null) ouder.appendChild(el("strong", null, m[1]));
      else {
        const label = m[2] != null ? m[2] : m[4];
        const l = veiligeLink(m[3] != null ? m[3] : m[4]);
        if (l) {
          const a = el("a", null, label);
          a.href = l.href;
          if (l.extern) { a.target = "_blank"; a.rel = "noopener noreferrer"; }
          ouder.appendChild(a);
        } else ouder.appendChild(document.createTextNode(label));
      }
      pos = re.lastIndex;
    }
    if (pos < tekst.length) ouder.appendChild(document.createTextNode(tekst.slice(pos)));
  };
  const opmaak = (tekst) => {
    const f = document.createDocumentFragment();
    for (const blok of String(tekst || "").replace(/\r/g, "").split(/\n{2,}/)) {
      let p = null, lijst = null, soort = "";
      for (const regel of blok.split("\n")) {
        if (!regel.trim()) continue;
        const m = /^\s*(?:([-*•])|(\d{1,3})[.)])\s+(.*)$/.exec(regel);
        if (m) {
          const s = m[1] ? "ul" : "ol";
          if (!lijst || soort !== s) { lijst = el(s); soort = s; f.appendChild(lijst); }
          const li = el("li");
          inline(li, m[3]);
          lijst.appendChild(li);
          p = null;
          continue;
        }
        lijst = null;
        const kop = /^\s*#{1,6}\s+(.*)$/.exec(regel);          // geen koppen in de chat: als vette regel
        if (p) p.appendChild(el("br")); else { p = el("p"); f.appendChild(p); }
        if (kop) p.appendChild(el("strong", null, kop[1])); else inline(p, regel);
      }
    }
    return f;
  };

  // ---------- bedragen zoals de winkel ze schrijft (Shopify money_format) ----------
  const scheid = (c, dec, duizend, decimalen) => {
    const [heel, frac] = (c / 100).toFixed(decimalen).split(".");
    return heel.replace(/\B(?=(\d{3})+(?!\d))/g, duizend) + (decimalen ? dec + frac : "");
  };
  const GELDVORM = {
    amount: (c) => scheid(c, ".", ",", 2), amount_no_decimals: (c) => scheid(c, ".", ",", 0),
    amount_with_comma_separator: (c) => scheid(c, ",", ".", 2), amount_no_decimals_with_comma_separator: (c) => scheid(c, ",", ".", 0),
    amount_with_apostrophe_separator: (c) => scheid(c, ".", "'", 2), amount_no_decimals_with_space_separator: (c) => scheid(c, ",", " ", 0),
    amount_with_space_separator: (c) => scheid(c, ",", " ", 2), amount_with_period_and_space_separator: (c) => scheid(c, ".", " ", 2),
  };
  // Bedragen zoals de winkel ze schrijft: nl en de volgens het thema als dat een valutateken heeft, anders nl "€24,95";
  // de, fr en en volgens de taal ("24,95 €"). De winkel heeft nu een formaat zonder teken ({{amount_with_comma_separator}}).
  const geld = (centen) => {
    const vorm = /\{\{\s*(\w+)\s*\}\}/.exec(GELD);
    const metTeken = !!(vorm && GELDVORM[vorm[1]] && GELD.replace(vorm[0], "").trim());
    if (metTeken && (TAAL === "nl" || TAAL === "de")) return GELD.replace(vorm[0], GELDVORM[vorm[1]](centen));
    if (TAAL === "nl" && VALUTA === "EUR") return "€" + GELDVORM.amount_with_comma_separator(centen);
    try { return new Intl.NumberFormat(LOCALE, { style: "currency", currency: VALUTA }).format(centen / 100); } catch (e) { return `${GELDVORM.amount_with_comma_separator(centen)} €`; }
  };
  const isCenten = (n) => Number.isSafeInteger(n) && n >= 0;
  const tijdTekst = (ms) => { try { return new Intl.DateTimeFormat(LOCALE, { hour: "2-digit", minute: "2-digit" }).format(new Date(ms)); } catch (e) { return ""; } };
  const blokTekst = (ms) => {
    const dag = new Date(ms), nu = new Date();
    if (dag.toDateString() === nu.toDateString()) return `${T.vandaag} ${tijdTekst(ms)}`;
    try { return `${new Intl.DateTimeFormat(LOCALE, { day: "numeric", month: "short" }).format(dag)} ${tijdTekst(ms)}`; } catch (e) { return tijdTekst(ms); }
  };

  // ---------- opbouw (Shadow DOM: het thema raakt het venster niet, het venster raakt het thema niet) ----------
  const schaduw = host.attachShadow({ mode: "open" });
  const css = el("link");
  css.rel = "stylesheet";
  css.href = veiligeFoto(d.css) || "vct-chat.css";
  const W = el("div", "wortel");
  W.hidden = true;
  W.lang = TAAL;
  schaduw.append(css, W);

  const beeld = (cls) => {
    const w = el("span", cls);
    const merk = () => w.appendChild(el("span", "merk", "VCT"));
    const src = veiligeFoto(d.avatar);
    if (src) {
      const img = el("img");
      img.alt = "";
      img.decoding = "async";
      img.addEventListener("error", () => { img.remove(); merk(); }, { once: true });
      img.src = src;
      w.appendChild(img);
    } else merk();
    return w;
  };

  const knop = attr(knopEl("knop"), { "aria-expanded": "false", "aria-controls": "vct-venster", "aria-label": T.open });
  const dicht = el("span", "dicht");
  dicht.appendChild(icoon("omlaag", 26));
  const tel = attr(el("span", "teller"), { "aria-hidden": "true" });
  tel.hidden = true;
  knop.append(beeld("beeld"), dicht, tel);

  const wolk = el("div", "wolk");
  wolk.hidden = true;
  const wolkTekst = knopEl("wolk-tekst", PAGINA === "collection" ? T.uitnodiging_collectie : T.uitnodiging_product);
  const wolkSluit = attr(knopEl("wolk-sluit"), { "aria-label": T.uitnodiging_sluit });
  wolkSluit.appendChild(icoon("sluit", 16));
  wolk.append(wolkTekst, wolkSluit);

  const venster = attr(el("div", "venster"), { id: "vct-venster", role: "dialog", "aria-labelledby": "vct-titel", tabindex: "-1" });
  venster.hidden = true;
  const kop = el("div", "kop");
  const namen = el("div", "namen");
  namen.append(attr(el("div", "titel", T.titel), { id: "vct-titel" }), el("div", "sub", VOORBEELD ? `${T.sub} · ${T.voorbeeld}` : T.sub));
  const menuKnop = attr(knopEl("kopknop"), { "aria-label": T.menu, "aria-haspopup": "menu", "aria-expanded": "false", "aria-controls": "vct-menu" });
  menuKnop.appendChild(icoon("meer", 22));
  const sluitKnop = attr(knopEl("kopknop"), { "aria-label": T.sluit });
  sluitKnop.appendChild(icoon("sluit", 22));
  const menu = attr(el("div", "menu"), { id: "vct-menu", role: "menu" });
  menu.hidden = true;
  const menuNieuw = attr(knopEl(null, T.nieuw), { role: "menuitem" });
  const menuMens = attr(knopEl(null, T.mens), { role: "menuitem" });
  menu.append(menuNieuw, menuMens);
  kop.append(beeld("beeld"), namen, menuKnop, sluitKnop, menu);

  const midden = el("div", "midden");
  const log = attr(el("div", "log"), { role: "log", "aria-live": "polite", "aria-label": T.log_label, tabindex: "0" });
  const nieuwKnop = knopEl("nieuw", T.nieuw_bericht);
  nieuwKnop.hidden = true;
  midden.append(log, nieuwKnop);

  const form = el("form", "invoer");
  form.noValidate = true;
  const invoer = attr(el("textarea"), { rows: "1", maxlength: "1000", placeholder: T.invoer_ph, "aria-label": T.invoer_label, enterkeyhint: "send", autocomplete: "off" });
  const stuur = attr(el("button", "stuur"), { type: "submit", "aria-label": T.verstuur });
  stuur.appendChild(icoon("verstuur", 20));
  form.append(invoer, stuur);
  const voet = el("div", "voet");                                   // uit het voorbeeld van de designer
  voet.appendChild(document.createTextNode(`${T.disclaimer} `));
  const privacy = el("a", null, T.privacy);
  privacy.href = `${ROOT}policies/privacy-policy`;
  privacy.target = "_blank";
  privacy.rel = "noopener";
  voet.appendChild(privacy);
  const onderkant = el("div", "onderkant");
  onderkant.append(form, voet);
  venster.append(kop, midden, onderkant);
  const melding = attr(el("div", "sr"), { role: "status", "aria-live": "polite" });   // ongelezen, ook als het venster dicht is
  W.append(wolk, venster, knop, melding);

  // ---------- toestand ----------
  // sinds: hoogste nummer dat opgehaald is. gezien: tot dit nummer toonde dit venster klant- en assistentberichten al zelf
  // (uit de eigen invoer en de stroom); die komen bij het ophalen niet nog eens in beeld.
  const staat = { open: false, gestart: false, bezig: false, ongelezen: 0, laatste: null, sinds: 0, gezien: 0, poll: null,
    sessie: lees("sessionStorage", K.sessie), overdracht: lees("sessionStorage", K.overdracht) === "1", demo: 0 };
  let instelling = { actief: false, lead: false, winkelwagen: false };
  let gen = 0;                                          // wordt hoger bij "Nieuw gesprek": oude antwoorden vallen weg
  let cssKlaar = false, volg = true;
  const toon = () => { W.hidden = !(cssKlaar && instelling.actief); };
  // Focus niet laten verdwijnen als het knopje of formulier met focus weggaat of uit gaat.
  const houdFocus = (weg) => {
    const a = schaduw.activeElement;
    if (a && weg && (a === weg || (weg.contains && weg.contains(a)))) invoer.focus({ preventScroll: true });
  };
  css.addEventListener("load", () => { cssKlaar = true; toon(); });

  // ---------- scrollen: meelopen, behalve als de klant zelf omhoog heeft gescrold ----------
  let vorigeTop = 0;
  log.addEventListener("scroll", () => {                 // omhoog, hoe weinig ook, is de keuze van de klant
    const afstand = log.scrollHeight - log.scrollTop - log.clientHeight;
    if (afstand < 2) volg = true;
    else if (log.scrollTop < vorigeTop - 0.5) volg = false;
    vorigeTop = log.scrollTop;
    if (volg) nieuwKnop.hidden = true;
  }, { passive: true });
  const naarOnder = (zacht) => {
    log.scrollTo({ top: log.scrollHeight, behavior: zacht && !RUSTIG ? "smooth" : "auto" });
    nieuwKnop.hidden = true;
    volg = true;
  };
  const erbij = () => { if (volg) naarOnder(false); else nieuwKnop.hidden = false; };
  nieuwKnop.addEventListener("click", () => naarOnder(true));

  // ---------- berichten ----------
  const BLOK_MS = 10 * 60 * 1000;
  const plaats = (b) => {
    const nu = b.tijd || Date.now();
    const vorige = staat.laatste;
    const wissel = !vorige || vorige.van !== b.van || (b.van === "mens" && vorige.naam !== b.naam);
    if (!vorige || nu - vorige.tijd > BLOK_MS) log.appendChild(el("div", "tijd", blokTekst(nu)));
    const r = el("div", `rij ${b.van === "klant" ? "rechts" : "links"} ${wissel ? "wissel" : "zelfde"}`);
    if (b.van === "mens" && wissel && b.naam) r.appendChild(el("div", "naam", b.naam));
    const bal = el("div", `b ${b.van === "klant" ? "klant" : "bot"}`);
    if (b.van === "klant") bal.textContent = b.tekst; else bal.appendChild(opmaak(b.tekst));
    r.appendChild(bal);
    if (b.vertaald) r.appendChild(el("div", "vertaald", typeof b.vertaald === "string" ? b.vertaald : T.vertaald));
    bal.addEventListener("click", (e) => {                     // tijd bij aanraken
      if (e.target.closest("a")) return;
      let t = r.querySelector(".rij-tijd");
      if (t) t.remove(); else { t = el("div", "rij-tijd", tijdTekst(nu)); r.appendChild(t); }
    });
    log.appendChild(r);
    staat.laatste = { van: b.van, naam: b.naam || "", tijd: nu };
    return { r, bal };
  };

  const stroom = (mijn) => {
    const vorigeLaatste = staat.laatste, voor = log.lastElementChild;
    const { r, bal } = plaats({ van: "bot", tekst: "" });
    const tijdKop = r.previousElementSibling !== voor && r.previousElementSibling && r.previousElementSibling.classList.contains("tijd") ? r.previousElementSibling : null;
    bal.appendChild(attr(el("span", "typen", "•••"), { role: "img", "aria-label": T.typen }));
    log.setAttribute("aria-busy", "true");
    erbij();
    let tekst = "", klaar = false;
    return {
      tekst(stuk) {
        if (klaar || mijn !== gen) return;
        tekst = (tekst + String(stuk)).slice(0, 8000);
        bal.textContent = "";
        bal.appendChild(opmaak(tekst));
        erbij();
      },
      fout(melding) {
        if (mijn !== gen) return;
        if (!tekst) { tekst = String(melding); bal.textContent = ""; bal.appendChild(opmaak(melding)); } else this.tekst("\n\n" + melding);
      },
      klaar() {
        if (klaar) return;
        klaar = true;
        if (mijn !== gen) return;
        log.setAttribute("aria-busy", "false");
        if (!tekst) {                                    // geen tekst: lege ballon weg, blokstand terug
          const erna = r.nextElementSibling;
          r.remove();
          if (!erna) { if (tijdKop) tijdKop.remove(); staat.laatste = vorigeLaatste; }
        } else if (!staat.open) { staat.ongelezen++; teller(); }
      },
    };
  };

  const kaarten = (lijst) => {
    const rij = attr(el("div", "kaarten"), { role: "list" });
    for (const k of (Array.isArray(lijst) ? lijst : []).slice(0, 8)) {
      if (!k || typeof k !== "object" || !k.titel) continue;
      const kaart = attr(el("div", "kaart"), { role: "listitem" });
      const url = veiligeLink(k.url);
      const a = el(url ? "a" : "div", "k-link");
      if (url) a.href = url.href;
      const foto = el("div", "foto");
      const src = veiligeFoto(k.afbeelding);
      if (src) { const img = el("img"); img.alt = ""; img.loading = "lazy"; img.decoding = "async"; img.src = src; foto.appendChild(img); } else foto.appendChild(icoon("foto", 28));
      a.append(foto, el("div", "k-titel", String(k.titel).slice(0, 200)));
      const b = k.beoordeling;
      if (b && Number(b.sterren) > 0 && Number(b.sterren) <= 5) {
        const w = Math.round(Number(b.sterren) * 10) / 10, heel = Math.round(w);
        const s = el("div", "k-sterren");
        s.appendChild(attr(el("span", "ster", "★".repeat(heel) + "☆".repeat(5 - heel)), { role: "img", "aria-label": vul(T.sterren, { w: w.toLocaleString(LOCALE) }) }));
        if (Number.isSafeInteger(b.aantal) && b.aantal > 0) s.appendChild(attr(el("span", "aantal", `(${b.aantal})`), { "aria-label": vul(T.aantal, { n: b.aantal }) }));
        a.appendChild(s);
      }
      const p = el("div", "k-prijs");
      if (isCenten(k.prijs)) {
        const advies = isCenten(k.adviesprijs) && k.adviesprijs > k.prijs;
        if (advies) p.appendChild(el("span", "sr", `${T.prijs_nu} `));
        p.appendChild(el("span", "prijs", geld(k.prijs)));
        if (advies) p.append(el("span", "sr", ` ${T.prijs_advies} `), el("s", "advies", geld(k.adviesprijs)));
      } else p.appendChild(el("span", "k-zie", T.bekijk_prijs));          // nooit een prijs raden
      a.appendChild(p);
      kaart.appendChild(a);
      const variant = String(k.variant == null ? "" : k.variant);
      if (instelling.winkelwagen && /^\d{1,16}$/.test(variant) && Number.isSafeInteger(Number(variant)) && k.beschikbaar !== false) {
        const kb = knopEl("k-knop", T.in_winkelwagen);
        kb.addEventListener("click", () => inWinkelwagen(Number(variant), kb));
        kaart.appendChild(kb);
      }
      rij.appendChild(kaart);
    }
    if (rij.childNodes.length) { log.appendChild(rij); erbij(); }
  };

  const inWinkelwagen = async (variant, kb) => {
    houdFocus(kb);
    kb.disabled = true;
    try {
      if (window.Shopify) {
        const r = await fetch(`${ROOT}cart/add.js`, { method: "POST", credentials: "same-origin", signal: signaal(15000),
          headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] }) });
        if (!r.ok) throw new Error(String(r.status));
      }
      kb.textContent = T.toegevoegd;
      kb.classList.add("ok");
      document.dispatchEvent(new CustomEvent("vct-chat:winkelwagen", { detail: { variant: String(variant) } }));
    } catch (e) {
      kb.disabled = false;
      plaats({ van: "bot", tekst: T.fout_winkelwagen });
      erbij();
    }
  };

  const wisKnoppen = () => log.querySelectorAll(".chips").forEach((c) => c.remove());
  const knoppen = (lijst) => {
    const c = el("div", "chips");
    for (const x of (Array.isArray(lijst) ? lijst : []).slice(0, 6)) {
      const tekst = String(typeof x === "string" ? x : (x && x.tekst) || "").slice(0, 80);
      if (!tekst) continue;
      const actie = (x && x.actie) || (tekst === T.mens ? "medewerker" : "");
      const b = knopEl("chip", tekst);
      b.addEventListener("click", () => {
        if (staat.bezig && actie !== "medewerker") return;
        houdFocus(c);
        c.remove();
        if (actie === "medewerker") medewerker(); else verstuur(tekst);
      });
      c.appendChild(b);
    }
    if (c.childNodes.length) { log.appendChild(c); erbij(); }
  };

  let veldNr = 0;
  const veld = (label, type, autocomplete) => {
    const id = `vct-veld-${++veldNr}`;
    const w = el("label", "veld");
    w.htmlFor = id;
    const i = attr(el("input"), { id, type, autocomplete, maxlength: type === "email" ? "254" : "100" });
    w.append(el("span", null, label), i);
    return { w, i };
  };
  const leadFormulier = () => {
    if (!instelling.lead || lees("sessionStorage", K.lead) || log.querySelector(".lead")) return;
    const f = el("form", "lead");
    f.noValidate = true;
    const email = veld(T.email, "email", "email"), naam = veld(T.naam, "text", "name");
    const vink = el("label", "vink");
    const cb = attr(el("input"), { type: "checkbox" });
    cb.checked = true;
    vink.append(cb, el("span", null, T.meldingen));
    const fout = attr(el("div", "lead-fout"), { role: "alert" });
    fout.hidden = true;
    const ok = el("button", "lead-ok", T.opslaan);
    ok.type = "submit";
    const over = knopEl("lead-over", T.overslaan);
    const rij = el("div", "lead-knoppen");
    rij.append(ok, over);
    f.append(el("div", "lead-titel", T.lead_titel), el("p", "lead-uitleg", T.lead_uitleg), email.w, naam.w, vink, fout, rij);
    over.addEventListener("click", () => { schrijf("sessionStorage", K.lead, "over"); f.remove(); invoer.focus(); });
    f.addEventListener("submit", async (e) => {
      e.preventDefault();
      const adres = email.i.value.trim();
      if (adres.length > 254 || !/^[^\s@]{1,64}@[^\s@]+\.[^\s@]{2,}$/.test(adres)) {
        fout.textContent = T.ongeldig_email; fout.hidden = false; email.i.focus(); return;
      }
      houdFocus(f);
      ok.disabled = true;
      try {
        if (!VOORBEELD) await api("lead", { sessie: await sessie(), email: adres, naam: naam.i.value.trim().slice(0, 100), meldingen: cb.checked });
        schrijf("sessionStorage", K.lead, "ja");
        f.replaceWith(el("div", "lead-klaar", T.lead_ok));
      } catch (err) { fout.textContent = (err && err.bericht) || T.fout; fout.hidden = false; ok.disabled = false; email.i.focus(); }
    });
    log.appendChild(f);
    erbij();
  };

  const teamKaart = () => {
    const t = el("div", "team");
    const src = veiligeFoto(d.team);
    if (src) {
      const img = el("img");
      img.alt = "";
      img.addEventListener("error", () => img.remove(), { once: true });
      img.src = src;
      t.appendChild(img);
    }
    t.appendChild(el("div", null, T.team));
    log.appendChild(t);
    erbij();
  };

  // Bestelling opzoeken: ordernummer en e-mail gaan alleen naar de controle van de chatdienst, nooit in een chatbericht
  // of naar het taalmodel (docs/chat-bouwspec.md, sectie 11).
  const verifieerFormulier = () => {
    if (log.querySelector(".verifieer")) return;
    const f = el("form", "kaartje verifieer");
    f.noValidate = true;
    const nr = veld(T.ordernummer, "text", "off"), mail = veld(T.email, "email", "email");
    attr(nr.i, { maxlength: "30", spellcheck: "false", autocapitalize: "characters" });
    const fout = attr(el("div", "lead-fout"), { role: "alert" });
    fout.hidden = true;
    const zoek = el("button", "knop-cta", T.controleren);
    zoek.type = "submit";
    f.append(el("div", "lead-titel", T.verifieer_titel), el("p", "lead-uitleg", T.verifieer_uitleg), nr.w, mail.w, fout, zoek);
    const meld = (tekst, veldEl) => { fout.textContent = tekst; fout.hidden = false; if (veldEl) veldEl.focus(); };
    f.addEventListener("submit", async (e) => {
      e.preventDefault();
      const ordernummer = nr.i.value.trim().replace(/^#/, ""), email = mail.i.value.trim();
      if (!/^[A-Za-z0-9-]{1,30}$/.test(ordernummer)) { meld(T.ongeldig_order, nr.i); return; }
      if (email.length > 254 || !/^[^\s@]{1,64}@[^\s@]+\.[^\s@]{2,}$/.test(email)) { meld(T.ongeldig_email, mail.i); return; }
      houdFocus(f);
      zoek.disabled = true;
      fout.hidden = true;
      try {
        const r = VOORBEELD
          ? (await wacht(500), { ok: true, berichten: [{ van: "bot", tekst: vul(T.demo_status, { nr: ordernummer }) }],
            actie: { code: "voorbeeld", tekst: vul(T.demo_actie, { nr: ordernummer }), nr: ordernummer } })
          : await api("verifieer", { sessie: await sessie(), ordernummer, email });
        if (!r || r.ok !== true) { zoek.disabled = false; meld(String((r && r.bericht) || T.verifieer_fout).slice(0, 300), nr.i); return; }
        f.remove();                                                 // gegevens niet laten staan
        (Array.isArray(r.berichten) ? r.berichten : []).map(bericht).filter(Boolean).forEach(toonBericht);
        if (r.actie) actieKaart(r.actie);
      } catch (err) {
        zoek.disabled = false;
        meld((err && err.bericht) || T.fout);
      }
    });
    log.appendChild(f);
    erbij();
    nr.i.focus({ preventScroll: true });
  };

  // Bevestigen van een handeling (zoals annuleren): tekst en bedrag uit de chatdienst, een eenmalige code; het taalmodel
  // kan dit niet zelf uitvoeren (docs/chat-bouwspec.md, sectie 12).
  const actieKaart = (a) => {
    if (!a || typeof a !== "object") return;
    const code = String(a.code || "");
    if (!VOORBEELD && !/^[A-Za-z0-9_.-]{16,512}$/.test(code)) return;
    const k = el("div", "kaartje actie");
    k.appendChild(el("p", "actie-tekst", String(a.tekst || "").slice(0, 400)));
    const rij = el("div", "lead-knoppen");
    const ja = knopEl("knop-cta", String(a.ja || T.actie_ja).slice(0, 60));
    const nee = knopEl("lead-over", String(a.nee || T.actie_nee).slice(0, 60));
    rij.append(ja, nee);
    k.appendChild(rij);
    const kies = async (bevestig) => {
      houdFocus(k);
      ja.disabled = nee.disabled = true;
      try {
        const r = VOORBEELD
          ? (await wacht(500), { berichten: [{ van: "bot", tekst: vul(bevestig ? T.demo_geannuleerd : T.demo_niet, { nr: a.nr || "" }) }] })
          : await api("actie", { sessie: staat.sessie, code, bevestig });
        k.remove();
        (Array.isArray(r && r.berichten) ? r.berichten : []).map(bericht).filter(Boolean).forEach(toonBericht);
      } catch (err) {
        ja.disabled = nee.disabled = false;
        plaats({ van: "bot", tekst: (err && err.bericht) || T.fout });
        erbij();
      }
    };
    ja.addEventListener("click", () => kies(true));
    nee.addEventListener("click", () => kies(false));
    log.appendChild(k);
    erbij();
  };

  const feedbackRij = () => {
    const r = el("div", "feedback");
    r.appendChild(el("span", null, T.feedback_vraag));
    for (const [goed, tekst] of [[true, T.ja], [false, T.nee]]) {
      const b = knopEl("chip klein", tekst);
      b.addEventListener("click", () => {
        houdFocus(r);
        r.textContent = T.feedback_dank;
        if (!VOORBEELD) api("feedback", { sessie: staat.sessie, goed }).catch(() => {});
      });
      r.appendChild(b);
    }
    log.appendChild(r);
    erbij();
  };

  let aangekondigd = 0;
  const teller = () => {
    const n = staat.ongelezen;
    tel.hidden = staat.open || n <= 0;
    tel.textContent = n > 9 ? "9+" : String(n);
    knop.setAttribute("aria-label", staat.open ? T.sluit : (n > 0 ? `${T.open}, ${vul(T.ongelezen, { n })}` : T.open));
    if (staat.open || n <= 0) { aangekondigd = 0; melding.textContent = ""; }
    else if (n > aangekondigd) { aangekondigd = n; melding.textContent = `${T.titel}: ${vul(T.ongelezen, { n })}`; }
  };

  // ---------- verbinding met het paneel ----------
  const api = async (pad, body, ms) => {
    if (!API_OK) throw new Error("geen paneel");
    const r = await fetch(`${API}/api/chat/v1/${pad}`, { method: "POST", mode: "cors", credentials: "omit", signal: signaal(ms || 15000),
      headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
    if (!r.ok) {
      const fout = new Error(String(r.status));
      fout.status = r.status;
      if (r.status === 404 && body && body.sessie) vergeet();     // sessie onbekend of verlopen: de volgende keer opnieuw
      try { fout.bericht = String((await r.json()).bericht || "").slice(0, 300); } catch (e) { fout.bericht = ""; }
      throw fout;
    }
    return r.json();
  };
  const vergeet = () => {
    overdrachtAan(false);
    staat.sessie = null;
    staat.sinds = 0;
    staat.gezien = 0;
    for (const k of [K.sessie, K.gelezen, K.overdracht]) schrijf("sessionStorage", k, null);
  };
  const sessie = async () => {
    if (staat.sessie) return staat.sessie;
    const mijn = gen;
    const r = await api("gesprek", { taal: TAAL, pagina: { type: PAGINA.slice(0, 40), pad: PAD } });
    const s = String((r && r.sessie) || "");
    if (!/^[A-Za-z0-9_-]{16,128}$/.test(s)) throw new Error("sessie");
    if (mijn !== gen) throw new Error("vervallen");
    staat.sessie = s;
    schrijf("sessionStorage", K.sessie, s);
    return s;
  };
  const bericht = (b) => {
    if (!b || typeof b !== "object" || !["bot", "klant", "mens"].includes(b.van)) return null;
    const t = Date.parse(b.tijd);
    return { id: Number.isSafeInteger(b.id) && b.id > 0 ? b.id : 0, van: b.van, tekst: String(b.tekst == null ? "" : b.tekst).slice(0, 8000),
      naam: b.naam ? String(b.naam).slice(0, 60) : "", vertaald: b.vertaald === true || (typeof b.vertaald === "string" && b.vertaald.slice(0, 120)),
      tijd: Number.isFinite(t) ? t : Date.now(), kaarten: Array.isArray(b.kaarten) ? b.kaarten : null, knoppen: Array.isArray(b.knoppen) ? b.knoppen : null };
  };
  const toonBericht = (m) => {
    if (m.id) { if (m.id <= staat.sinds) return; staat.sinds = m.id; }
    if (m.id && m.id <= staat.gezien && m.van !== "mens") {         // al in beeld (eigen bericht of het gestreamde antwoord)
      if (staat.open) schrijf("sessionStorage", K.gelezen, staat.sinds);
      return;
    }
    if (m.tekst) plaats(m);
    if (m.kaarten) kaarten(m.kaarten);
    if (m.knoppen) knoppen(m.knoppen);
    if (staat.open) schrijf("sessionStorage", K.gelezen, staat.sinds);
    else if (m.van !== "klant") { staat.ongelezen++; teller(); }
    erbij();
  };
  const overdrachtAan = (aan) => {
    staat.overdracht = aan;
    schrijf("sessionStorage", K.overdracht, aan ? "1" : null);
    if (aan && !staat.poll && !VOORBEELD) staat.poll = setInterval(() => { if (document.visibilityState === "visible") haalNieuw(); }, 10000);
    if (!aan && staat.poll) { clearInterval(staat.poll); staat.poll = null; }
  };
  const haalNieuw = async () => {
    if (!staat.sessie) return;
    const sessieVooraf = staat.sessie, gestartVooraf = staat.gestart, genVooraf = gen;
    let r;
    try { r = await api("berichten", { sessie: staat.sessie, sinds: staat.sinds }); } catch (e) { return; }
    if (staat.sessie !== sessieVooraf || staat.gestart !== gestartVooraf || gen !== genVooraf) return;
    const lijst = (Array.isArray(r && r.berichten) ? r.berichten : []).map(bericht).filter(Boolean);
    if (!staat.gestart) {                              // venster nog dicht op deze pagina: alleen tellen
      const gelezen = Number(lees("sessionStorage", K.gelezen) || 0);
      for (const m of lijst) {
        if (m.id && m.id <= staat.sinds) continue;
        if (m.id) staat.sinds = m.id;
        if (m.van !== "klant" && m.id > gelezen && (m.van === "mens" || m.id > staat.gezien)) staat.ongelezen++;
      }
      teller();
    } else lijst.forEach(toonBericht);
    if (r && r.overdracht === false) overdrachtAan(false);
    else if (r && r.overdracht === true && !staat.overdracht) overdrachtAan(true);
  };
  const herstel = async () => {
    staat.sinds = 0;
    staat.gezien = 0;
    const mijn = gen;
    let lijst = [], r = null;
    try { r = await api("berichten", { sessie: staat.sessie, sinds: 0 }); lijst = (Array.isArray(r && r.berichten) ? r.berichten : []).map(bericht).filter(Boolean); } catch (e) { /* dan opnieuw beginnen */ }
    if (mijn !== gen) return;
    if (r && r.overdracht === true && !staat.overdracht) overdrachtAan(true);    // bijvoorbeeld: een medewerker antwoordde al
    if (!lijst.length) { welkom(); return; }
    lijst.forEach(toonBericht);
    schrijf("sessionStorage", K.gelezen, staat.sinds);
    naarOnder(false);
  };

  const gebeurtenis = (ev, s, mijn) => {
    if (!ev || typeof ev !== "object" || mijn !== gen) return;
    switch (ev.t) {
      case "tekst": s.tekst(ev.d == null ? "" : ev.d); break;
      case "id":
        if (!Number.isSafeInteger(ev.d) || ev.d <= 0) break;
        // Tijdens een overdracht kan een medewerker intussen geantwoord hebben, met een lager nummer dat nog niet is
        // opgehaald. Dus niet over dat antwoord heen springen: eerst ophalen, en wat dit venster al toonde niet nog eens.
        if (staat.overdracht) { staat.gezien = Math.max(staat.gezien, ev.d); haalNieuw(); }
        else if (ev.d > staat.sinds) staat.sinds = ev.d;
        break;
      case "kaarten": kaarten(ev.d); break;
      case "knoppen": knoppen(ev.d); break;
      case "lead": leadFormulier(); break;
      case "overdracht": overdrachtAan(true); teamKaart(); break;
      case "feedback": feedbackRij(); break;
      case "verifieer": verifieerFormulier(); break;
      case "actie": actieKaart(ev.d); break;
      case "fout": s.fout(String(ev.d || T.fout).slice(0, 500)); break;
      default: break;                                  // onbekend: negeren
    }
  };
  const stuurBericht = async (tekst, mijn) => {
    const s = stroom(mijn);
    const ctl = new AbortController();
    staat.ctl = ctl;
    const klok = setTimeout(() => ctl.abort(), 90000);
    const verstuurNaar = async () => fetch(`${API}/api/chat/v1/bericht`, { method: "POST", mode: "cors", credentials: "omit", signal: ctl.signal,
      headers: { "Content-Type": "application/json", Accept: "application/x-ndjson" }, body: JSON.stringify({ sessie: await sessie(), tekst }) });
    try {
      let r = await verstuurNaar();
      if (r.status === 404) { vergeet(); r = await verstuurNaar(); }          // sessie verlopen: eenmaal opnieuw, met een nieuwe
      if (r.status === 429) {                          // limiet of budget: de chatdienst zegt wat de klant kan doen
        const j = await r.json().catch(() => ({}));
        s.fout(String((j && j.bericht) || T.fout).slice(0, 500));
        // De vraag staat nu bij de klantenservice: pollen, zodat het antwoord van een medewerker hier verschijnt.
        if (j && j.overdracht === true && !staat.overdracht && mijn === gen) { overdrachtAan(true); teamKaart(); }
        return;
      }
      if (!r.ok || !r.body) throw new Error(String(r.status));
      const lezer = r.body.getReader();
      const dec = new TextDecoder();
      let rest = "";
      for (;;) {
        const { value, done } = await lezer.read();
        if (done || mijn !== gen) break;
        rest += dec.decode(value, { stream: true });
        if (rest.length > 200000) throw new Error("te groot");
        let i;
        while ((i = rest.indexOf("\n")) >= 0) {
          const regel = rest.slice(0, i).trim();
          rest = rest.slice(i + 1);
          if (regel) gebeurtenis(JSON.parse(regel), s, mijn);
        }
      }
      if (rest.trim() && mijn === gen) gebeurtenis(JSON.parse(rest), s, mijn);
    } catch (e) {
      s.fout(T.fout);
    } finally {
      clearTimeout(klok);
      if (staat.ctl === ctl) staat.ctl = null;
      s.klaar();
      if (staat.open && mijn === gen) schrijf("sessionStorage", K.gelezen, staat.sinds);
    }
  };

  // ---------- voorbeeld (alleen in de thema-editor en op voorbeeld.html; praat niet met het paneel) ----------
  const centen = (x) => { const n = Math.round(parseFloat(String(x)) * 100); return Number.isSafeInteger(n) && n > 0 ? n : null; };
  const demoProducten = async () => {
    if (window.Shopify) {
      try {
        const r = await fetch(`${ROOT}search/suggest.json?q=H7&resources[type]=product&resources[limit]=4`, { credentials: "same-origin", signal: signaal(8000) });
        const j = await r.json();
        const p = (((j || {}).resources || {}).results || {}).products || [];
        const lijst = p.map((x) => ({ titel: x.title, url: x.url, afbeelding: (x.featured_image && x.featured_image.url) || x.image, prijs: centen(x.price),
          adviesprijs: centen(x.compare_at_price_max), variant: x.variants && x.variants[0] && x.variants[0].id, beschikbaar: x.available }));
        if (lijst.length) return lijst;
      } catch (e) { /* dan de voorbeeldkaarten */ }
    }
    return [{ titel: T.demo_product, prijs: 2495, adviesprijs: 2995, beoordeling: { sterren: 4.8, aantal: 126 }, variant: 1 },
      { titel: T.demo_product2, prijs: 1495, beoordeling: { sterren: 4.6, aantal: 38 }, variant: 2 }];
  };
  const demoAntwoord = async (mijn) => {
    staat.demo++;
    const s = stroom(mijn);
    await wacht(500);
    for (let i = 0; i < T.demo_antwoord.length && mijn === gen; i += 4) { s.tekst(T.demo_antwoord.slice(i, i + 4)); await wacht(12); }
    s.klaar();
    const lijst = await demoProducten();
    if (mijn !== gen) return;
    kaarten(lijst);
    if (staat.demo === 1) leadFormulier(); else feedbackRij();
  };
  const demoBestelling = async (mijn) => {
    const s = stroom(mijn);
    await wacht(400);
    s.tekst(T.demo_verifieer);
    s.klaar();
    if (mijn === gen) verifieerFormulier();
  };
  const demoMedewerker = async (mijn) => {
    plaats({ van: "bot", tekst: T.mens_bezig });
    teamKaart();
    await wacht(2500);
    if (mijn !== gen) return;
    toonBericht({ id: 0, van: "mens", naam: "Mel", tekst: T.demo_mens, vertaald: TAAL !== "nl", tijd: Date.now() });
  };

  // ---------- acties ----------
  const knopStaat = () => {
    const uit = staat.bezig || !invoer.value.trim();
    if (uit && schaduw.activeElement === stuur) invoer.focus({ preventScroll: true });
    stuur.disabled = uit;
  };
  const welkom = () => {
    plaats({ van: "bot", tekst: T.welkom });
    knoppen(T.snel.map((t, i) => (i === 3 ? { tekst: t, actie: "medewerker" } : t)));
  };
  const verstuur = async (ruw) => {
    const tekst = String(ruw || "").trim().slice(0, 1000);
    if (!tekst || staat.bezig) return;
    const mijn = gen;
    staat.bezig = true;
    schrijf("localStorage", K.actief, Date.now());
    knopStaat();
    wisKnoppen();
    plaats({ van: "klant", tekst });
    naarOnder(false);
    try {
      if (VOORBEELD) await (/bestel|order|commande/i.test(tekst) ? demoBestelling(mijn) : demoAntwoord(mijn));
      else await stuurBericht(tekst, mijn);
    } finally { if (mijn === gen) { staat.bezig = false; knopStaat(); } }
  };
  const medewerker = async () => {
    sluitMenu(invoer);
    if (!staat.open) open();
    wisKnoppen();
    const mijn = gen;
    if (VOORBEELD) { await demoMedewerker(mijn); return; }
    try {
      const r = await api("medewerker", { sessie: await sessie() });
      if (mijn !== gen) return;
      (Array.isArray(r && r.berichten) ? r.berichten : []).map(bericht).filter(Boolean).forEach(toonBericht);
      overdrachtAan(true);
      teamKaart();
      if (r && r.lead) leadFormulier();
    } catch (e) { if (mijn === gen) { plaats({ van: "bot", tekst: (e && e.bericht) || T.fout }); erbij(); } }
  };
  const nieuwGesprek = () => {
    sluitMenu(invoer);
    gen++;                                              // lopende antwoorden en verzoeken vallen weg
    if (staat.ctl) { staat.ctl.abort(); staat.ctl = null; }
    staat.bezig = false;
    log.setAttribute("aria-busy", "false");
    overdrachtAan(false);
    for (const k of [K.sessie, K.gelezen, K.lead]) schrijf("sessionStorage", k, null);
    Object.assign(staat, { sessie: null, sinds: 0, gezien: 0, laatste: null, ongelezen: 0, demo: 0 });
    log.textContent = "";
    vorigeTop = 0;
    volg = true;
    welkom();
    knopStaat();
    invoer.focus();
  };

  // ---------- openen en sluiten ----------
  let oudeOverflow = null;
  const vergrendel = (aan) => {                        // mobiel: de pagina eronder scrolt niet mee
    const de = document.documentElement;
    if (aan && oudeOverflow === null) { oudeOverflow = de.style.overflow; de.style.overflow = "hidden"; }
    if (!aan && oudeOverflow !== null) { de.style.overflow = oudeOverflow; oudeOverflow = null; }
  };
  // Mobiel met schermtoetsenbord: het venster volgt het zichtbare deel, zodat kop en sluitknop in beeld blijven.
  let vvAan = false, vvRaf = 0;
  const vvPas = () => {
    vvRaf = 0;
    const vv = window.visualViewport;
    if (!vv || !vvAan) return;
    venster.style.top = `${vv.offsetTop}px`;
    venster.style.bottom = "auto";
    venster.style.height = `${vv.height}px`;
    if (volg) naarOnder(false);
  };
  const vvGebeurt = () => { if (!vvRaf) vvRaf = requestAnimationFrame(vvPas); };
  const volgViewport = (aan) => {
    const vv = window.visualViewport;
    if (!vv) return;
    if (aan && !vvAan) { vvAan = true; vv.addEventListener("resize", vvGebeurt); vv.addEventListener("scroll", vvGebeurt); vvPas(); }
    if (!aan && vvAan) {
      vvAan = false;
      vv.removeEventListener("resize", vvGebeurt);
      vv.removeEventListener("scroll", vvGebeurt);
      venster.style.top = venster.style.bottom = venster.style.height = "";
    }
  };
  const mobielStand = () => {
    const mob = staat.open && MOBIEL.matches;
    W.classList.toggle("mobiel", MOBIEL.matches);
    W.classList.toggle("mobiel-open", mob);
    attr(venster, { "aria-modal": mob ? "true" : "false" });
    vergrendel(mob);
    volgViewport(mob);
  };
  const open = () => {
    if (staat.open) return;
    staat.open = true;
    verbergWolk(false);
    markeerUitgenodigd();                               // wie de chat al gebruikt, krijgt geen uitnodiging meer
    schrijf("localStorage", K.actief, Date.now());
    venster.hidden = false;
    knop.classList.add("open");
    knop.setAttribute("aria-expanded", "true");
    mobielStand();
    if (!staat.gestart) {
      staat.gestart = true;
      if (staat.sessie && !VOORBEELD) herstel(); else welkom();
    }
    staat.ongelezen = 0;
    schrijf("sessionStorage", K.gelezen, staat.sinds);
    teller();
    naarOnder(false);
    (MOBIEL.matches ? venster : invoer).focus({ preventScroll: true });
  };
  const sluit = () => {
    if (!staat.open) return;
    staat.open = false;
    sluitMenu();
    venster.hidden = true;
    knop.classList.remove("open");
    knop.setAttribute("aria-expanded", "false");
    mobielStand();
    teller();
    knop.focus({ preventScroll: true });
  };
  const sluitMenu = (naar) => {
    const hadFocus = !menu.hidden && menu.contains(schaduw.activeElement);
    menu.hidden = true;
    menuKnop.setAttribute("aria-expanded", "false");
    if (hadFocus && naar) naar.focus({ preventScroll: true });
  };
  const openMenu = () => { menu.hidden = false; menuKnop.setAttribute("aria-expanded", "true"); menuNieuw.focus(); };

  knop.addEventListener("click", () => (staat.open ? sluit() : open()));
  sluitKnop.addEventListener("click", sluit);
  menuKnop.addEventListener("click", () => (menu.hidden ? openMenu() : sluitMenu()));
  menuNieuw.addEventListener("click", nieuwGesprek);
  menuMens.addEventListener("click", medewerker);
  menu.addEventListener("keydown", (e) => {
    if (e.key === "Tab") { sluitMenu(); return; }        // Tab verlaat het menu en sluit het
    if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
    e.preventDefault();
    (schaduw.activeElement === menuNieuw ? menuMens : menuNieuw).focus();
  });
  W.addEventListener("click", (e) => { if (!menu.hidden && !menu.contains(e.target) && !menuKnop.contains(e.target)) sluitMenu(); });
  document.addEventListener("click", (e) => { if (!menu.hidden && !e.composedPath().includes(host)) sluitMenu(); });
  W.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      if (!menu.hidden) { sluitMenu(); menuKnop.focus(); } else if (staat.open) sluit();
      return;
    }
    if (e.key === "Tab" && staat.open && MOBIEL.matches) {  // mobiel volledig scherm: focus blijft in het venster
      const f = [...venster.querySelectorAll("button, textarea, input, a[href], [tabindex='0']")].filter((x) => !x.disabled && x.getClientRects().length);
      if (!f.length) return;
      const nu = schaduw.activeElement;
      if (e.shiftKey && (nu === f[0] || nu === venster)) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && nu === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  MOBIEL.addEventListener("change", mobielStand);
  mobielStand();
  // Toetsen in de velden van de chat blijven in de chat: sneltoetsen van het thema (zoals "/" voor zoeken) krijgen ze niet.
  schaduw.addEventListener("keydown", (e) => {
    const t = e.composedPath()[0];
    if (t && (t.tagName === "TEXTAREA" || t.tagName === "INPUT")) e.stopPropagation();
  });
  // Vangnet: raakt de focus toch kwijt terwijl het venster open is, dan werken Esc en de focusval op mobiel nog.
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && staat.open && document.activeElement === document.body) sluit(); });
  document.addEventListener("focusin", (e) => { if (staat.open && MOBIEL.matches && !e.composedPath().includes(host)) venster.focus({ preventScroll: true }); });

  const groei = () => { invoer.style.height = "auto"; invoer.style.height = `${Math.min(invoer.scrollHeight, 120)}px`; };
  invoer.addEventListener("input", () => { groei(); knopStaat(); });
  invoer.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && !e.shiftKey && !e.isComposing) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event("submit", { cancelable: true })); }
  });
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const t = invoer.value;
    if (!t.trim() || staat.bezig) return;
    invoer.value = "";
    groei();
    verstuur(t);
  });
  knopStaat();

  // ---------- uitnodiging: hooguit één per sessie, product- en collectiepagina's, na 30 seconden, nooit over de koopknop ----------
  // Een koopknop is elke knop die naar /cart/add verstuurt (ook via het attribuut form=, zoals de vaste koopbalk van het
  // thema), de vaste koopbalk zelf, of een element met data-vct-koopknop.
  const isKoop = (k) => k.hasAttribute("data-vct-koopknop") || !!k.closest("#sticky-add-to-cart")
    || (k.type === "submit" && !!k.form && /\/cart\/add(?:[?#/.]|$)/.test(k.form.getAttribute("action") || ""));
  const overlapt = (a) => [...document.querySelectorAll("button, input[type='submit'], [data-vct-koopknop]")].filter(isKoop).some((k) => {
    const r = k.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.left < a.right && r.right > a.left && r.top < a.bottom && r.bottom > a.top;
  });
  let wolkPogingen = 0;
  // Eén uitnodiging per bezoek, ook over tabbladen heen; 30 minuten zonder activiteit is een nieuw bezoek.
  const BEZOEK_MS = 30 * 60 * 1000;
  if (Date.now() - Number(lees("localStorage", K.actief) || 0) > BEZOEK_MS) schrijf("localStorage", K.uitgenodigdOp, null);
  schrijf("localStorage", K.actief, Date.now());
  const alUitgenodigd = () => !!(lees("sessionStorage", K.uitgenodigd) || lees("localStorage", K.uitgenodigdOp) || lees("localStorage", K.weg));
  function markeerUitgenodigd() { schrijf("sessionStorage", K.uitgenodigd, "1"); schrijf("localStorage", K.uitgenodigdOp, Date.now()); }
  const verbergWolk = (weg) => {
    if (wolk.hidden) return;
    wolk.hidden = true;
    if (weg) schrijf("localStorage", K.weg, "1");
  };
  const probeerWolk = (altijd) => {
    if (staat.open || !wolk.hidden) return;
    if (!altijd && alUitgenodigd()) return;
    wolk.classList.add("meet");
    wolk.hidden = false;
    if (overlapt(wolk.getBoundingClientRect())) {
      wolk.hidden = true;
      wolk.classList.remove("meet");
      if (++wolkPogingen < 6) setTimeout(() => probeerWolk(altijd), 5000);
      return;
    }
    wolk.classList.remove("meet");
    markeerUitgenodigd();
  };
  window.addEventListener("scroll", () => { if (!wolk.hidden && overlapt(wolk.getBoundingClientRect())) verbergWolk(false); }, { passive: true });
  wolkTekst.addEventListener("click", open);
  wolkSluit.addEventListener("click", () => verbergWolk(true));
  const planUitnodiging = () => {
    if (!VOORBEELD && !["product", "collection"].includes(PAGINA)) return;
    if (!VOORBEELD && alUitgenodigd()) return;
    let rest = VOORBEELD ? 1500 : 30000, begin = 0, klok = null;
    const start = () => { if (klok || document.visibilityState !== "visible") return; begin = Date.now(); klok = setTimeout(() => { document.removeEventListener("visibilitychange", wissel); probeerWolk(VOORBEELD); }, rest); };
    const wissel = () => {
      if (document.visibilityState === "visible") start();
      else if (klok) { clearTimeout(klok); klok = null; rest = Math.max(0, rest - (Date.now() - begin)); }
    };
    document.addEventListener("visibilitychange", wissel);
    start();
  };

  // ---------- aan het werk ----------
  // Status per taal onthouden (vctparts.be en /fr delen dezelfde opslag), en alleen een echt antwoord: een storing of
  // time-out wordt niet 10 minuten lang als "uit" onthouden.
  const status = async () => {
    const sleutel = `${K.status}:${TAAL}`;
    const vorm = (x) => ({ actief: x.actief === true, lead: x.lead === true, winkelwagen: x.winkelwagen === true });
    const c = lees("sessionStorage", sleutel);
    if (c) { try { const o = JSON.parse(c); if (o && Date.now() - o.t < 600000 && o.s && typeof o.s === "object") return vorm(o.s); } catch (e) { /* opnieuw vragen */ } }
    try {
      const r = await fetch(`${API}/api/chat/v1/status?taal=${TAAL}`, { mode: "cors", credentials: "omit", signal: signaal(8000) });
      if (!r.ok) throw new Error(String(r.status));
      const s = vorm(await r.json());
      schrijf("sessionStorage", sleutel, JSON.stringify({ t: Date.now(), s }));
      return s;
    } catch (e) {
      return { actief: false, lead: false, winkelwagen: false, storing: true };
    }
  };

  if (VOORBEELD) {
    window.VCTChatVoorbeeld = Object.freeze({
      uitnodiging: () => { wolkPogingen = 0; probeerWolk(true); },
      ongelezen: (n) => { staat.ongelezen = Math.max(0, Math.floor(Number(n) || 0)); teller(); },
      medewerker: () => medewerker(),
      bestelling: () => { if (!staat.open) open(); demoBestelling(gen); },
      bot: (t) => { if (!staat.open) open(); plaats({ van: "bot", tekst: String(t) }); erbij(); },
    });
  }

  (async () => {
    instelling = VOORBEELD ? { actief: true, lead: true, winkelwagen: true } : (API_OK ? await status() : instelling);
    // Chatdienst even niet bereikbaar terwijl een klant op een medewerker wacht: venster toch tonen, zodat het antwoord
    // niet zoekraakt. Anders: uit of onbereikbaar betekent niets tonen.
    if (instelling.storing && staat.overdracht && staat.sessie) instelling = { actief: true, lead: false, winkelwagen: false };
    if (!instelling.actief) return;
    toon();
    planUitnodiging();
    if (!VOORBEELD && staat.overdracht && staat.sessie) { overdrachtAan(true); haalNieuw(); }
  })();
})();
